import Alpine from 'alpinejs';

Alpine.data('shippingCalculator', (availableCountries) => ({
  working: false,
  zip: '',
  country: '',
  province: '',
  rates: [],
  availableCountries: availableCountries,
  getShippingRates() {
    this.working = true;
    this.rates = [];

    Shopify.cart.prepareShippingRates(this.zip, this.country, this.province).then(() => {
      const fetchRates = () => {
        Shopify.cart.asyncShippingRates(this.zip, this.country, this.province).then((rates) => {
          if (rates.shipping_rates) {
            this.rates = rates.shipping_rates;
            return;
          }

          fetchRates();
        });
      };
      fetchRates();
    }).catch((error) => {
      this.$dispatch('toast:show', {
        message: error.message,
        timeout: 2000,
        type: 'error',
      }, true);
    }).finally(() => {
      this.working = false;
    });
  }
}));